import { useMutation, useQueryClient } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import {
  ICreditTransaction,
  IUpdateCreditTransactionPayload,
} from "../types/creditTransaction";

const API = process.env.REACT_APP_API;

const useUpdateCreditTransaction = () => {
  const fetch = useFetch();
  const queryClient = useQueryClient();

  return useMutation(
    (payload: IUpdateCreditTransactionPayload) => {
      const { id, ...data } = payload;
      return fetch(`${API}/api/semeadora/credit-transactions/${id}/`, {
        method: "PATCH",
        body: data,
      }) as Promise<ICreditTransaction>;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["credit-transactions"]);
        queryClient.invalidateQueries(["urban-partners"]);
      },
    },
  );
};

export default useUpdateCreditTransaction;
